// File-upload constants — relocated out of CustomFileUploader.vue so the component
// carries no module-scope data tables.

export const DEFAULT_MAX_FILE_SIZE = 52_428_800; // 50 MB per AQ-W5-10

// SasUploader's client-side size cap (MB). Single source so the SasUploader prop default, its
// call sites, and the "max N MB" helper copy can't drift (TP-6). Distinct from DEFAULT_MAX_FILE_SIZE
// (bytes, CustomFileUploader) — SasUploader enforces a tighter MB-denominated limit.
export const SAS_UPLOAD_MAX_FILE_SIZE_MB = 10;

export const EXT_TO_MIME: Record<string, string> = {
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".png": "image/png",
  ".gif": "image/gif",
  ".webp": "image/webp",
  ".bmp": "image/bmp",
  ".svg": "image/svg+xml",
  ".heic": "image/heic",
  ".heif": "image/heif",
  ".pdf": "application/pdf",
  ".csv": "text/csv",
  ".xls": "application/vnd.ms-excel",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".doc": "application/msword",
  ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ".zip": "application/zip",
  ".mp4": "video/mp4",
  ".mp3": "audio/mpeg",
};
